module.exports = __webpack_public_path__ + "static/media/car-2025538_640_color.4517e041.png";